import { api } from 'lib/httpClient';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

async function fetchFundInfo({ queryKey }) {
  const [, params] = queryKey;
  const {
    data: { data },
  } = await api.get(`investor-reporting/closed-funds`, {
    params,
  });
  return data;
}

export function useReportingFundInfo(firmId, submitDate, fundTypes) {
  return useQuery({
    queryKey: ['investor-reporting-fund', { firmId, submitDate, fundTypes }],
    queryFn: fetchFundInfo,
    enabled: !!firmId && !!submitDate && !!fundTypes,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
